import { createSlice } from '@reduxjs/toolkit';
import absWebService from 'app/services/absWebService';
import i18next from 'i18next';
import { showMessage } from 'app/store/abs/messageSlice';

export const communicateWithAPI = (apicall, data) => async dispatch => {
	dispatch(setLoading(true));

	const response = await absWebService
		.communicationHandler(apicall, data)
		.catch(error => {
			if (error == null) {
				error = i18next.t("abswebservice:UNKNOWNERROR");
			}
			//give back error for processing below
			return error;
		});

	//await catch error or server response
	const respdata = await response;

	dispatch(setLoading(false));

	if (absWebService.isResponseArrSuccess(respdata)) {
		//alert(JSON.stringify(respdata));

		switch (apicall) {
			case "abs_supportrequest":
				var returndataarr = JSON.parse(absWebService.getDataFromResponseArr(respdata));

				dispatch(showMessage({ message: returndataarr, variant: 'success' }));
				break;
			default:
				dispatch(showMessage({ message: "success fetching data", variant: 'success' }));
				break;
		}

		return absWebService.getDataFromResponseArr(respdata);
	}
	else {
		var errormessage = absWebService.getDisplayTextFromResponseArr(respdata);
		dispatch(showMessage({ message: errormessage, variant: 'error' }));
		return "error";
	}
};

const initialState = {
	loading: false,
};

const helperSlice = createSlice({
	name: 'abshelper',
	initialState,
	reducers: {
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
	},
	extraReducers: {}
});

export const { setLoading } = helperSlice.actions;

export default helperSlice.reducer;
